const thwiftyImages = [
  {
    link: "/search/gaming laptops",
    image: "https://cdn.ebtida.com/1781139491834-WhatsAppImage2026-06-11at04.53.24.jpeg",
  },
  {
    link: "/search/refurbished",
    image: "https://cdn.ebtida.com/1772919847075-Banner2.jpg",
  },
];

const domain = "rockmycart.com";
const domainName = "rockmycart";
const domainName2 = "Rock My Cart";
const licenseNumber = "7007570";
const customerSupport = "8:00 AM to 10:00 PM UAE Time, 7 days a week";
const companyName = "Online World FZ LLC";
const domainLogo = "https://cdn.ebtida.com/1772809179969-rockmycart.png";
const bgColor = "#000";
const favicon = "https://cdn.ebtida.com/1773000246024-Favicon(1).png";
const email = "help@rockmycart.com";
const metaTitle = "Rockmycart: Your One-Stop Shop for Affordable Deals and Quality Products";
const metaDescription =
  "RockMyCart is a UAE-based e-commerce platform offering rock bottom deals on electronics, fashion, gadgets, accessories and more. Built to make online shopping fast, exciting, and affordable.";
const headerBg = "#000";
const subMenu = "#000";
const bannesImages = thwiftyImages;
const buttonColor = "#f7f7f7";
const address =
  "Compass Building<br />FDCW1862, Al Shohada Road<br /> Al Hamra Industrial Zone-FZ<br />Ras Al Khaimah, United Arab Emirates";
const phone = "+971 4 836 9557";

const Host = {
  domain: domain,
  domainName: domainName,
  domainName2: domainName2,
  licenseNumber: licenseNumber,
  customerSupport: customerSupport,
  companyName: companyName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannesImages: bannesImages,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
};

export default Host;
